import { render } from "./TableList.vue?vue&type=template&id=4494bf44&scoped=true&ts=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=4494bf44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4494bf44"]])

export default __exports__